var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDurationsvg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0026 1.08594C10.6457 1.08594 8.34174 1.78484 6.38206 3.09426C4.42237 4.40367 2.89499 6.2648 1.99305 8.44229C1.0911 10.6198 0.855111 13.0158 1.31492 15.3274C1.77473 17.639 2.90968 19.7623 4.57626 21.4289C6.24283 23.0955 8.36618 24.2304 10.6778 24.6903C12.9894 25.15 15.3854 24.9141 17.5629 24.0122C19.7404 23.1102 21.6015 21.5828 22.9109 19.6231C24.2203 17.6635 24.9192 15.3595 24.9192 13.0026C24.9155 9.84325 23.6589 6.81436 21.4248 4.58036C19.1908 2.34636 16.162 1.08967 13.0026 1.08594ZM17.0185 17.0185C16.8154 17.2217 16.5399 17.3357 16.2526 17.3357C15.9653 17.3357 15.6898 17.2217 15.4867 17.0185L12.2367 13.7685C12.0335 13.5654 11.9193 13.2899 11.9193 13.0026V6.5026C11.9193 6.21529 12.0334 5.93974 12.2366 5.73656C12.4397 5.53341 12.7153 5.41927 13.0026 5.41927C13.2899 5.41927 13.5655 5.53341 13.7686 5.73656C13.9718 5.93974 14.0859 6.21529 14.0859 6.5026V12.5541L17.0185 15.4867C17.2216 15.6898 17.3357 15.9653 17.3357 16.2526C17.3357 16.5398 17.2216 16.8154 17.0185 17.0185Z",
    fill: "#321E5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDurationsvg1);
export default __webpack_public_path__ + "static/media/duration.svg (1).257e343e471f18d8b5901603dc7cff0a.svg";
export { ForwardRef as ReactComponent };